import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader, Col, Row, FormGroup, Form } from 'reactstrap';
import Permissions from 'react-redux-permissions';
import InputGroup from '../../../components/cms/form/inputGroup';
import SubmitButtons from '../../../components/cms/form/submitButtons';
import ActiveButton from '../../../components/cms/activeButton';
import SubscriberService from "../../../services/subscriber.service";

const twoCols = { xs: 12, md: 6 };

const Subscriber = ({
  t,
  onChange,
  onSubmit,
  errors,
  formData,
  title,
  isSubmitting,
  isSubmittingRedirect,
  statusList,
  licenceList,
  showTrialEndDate,
  paymentStatusList,
  modules,
  paymentTypesList,
  licenceTimeTypes,
  start,
  deploy,
  stop,
}) => (
  <div>
    <Row>
      <Col md={12}>
        <Card>
          <CardHeader>
            <strong><i className="fa fa-id-card pr-2" />{title}</strong>
          </CardHeader>
          <CardBody>
            <Form onSubmit={onSubmit(true)}>
              {formData.id && (
                <Row>
                  <Col md={12}>
                    <ActiveButton
                      label={t('Deploy')}
                      color={'primary'}
                      icon={'rocket'}
                      className={'mr-1'}
                      disabled={formData.status !== SubscriberService.STATUS_PENDING}
                      onClickCallback={deploy}
                    />
                    <ActiveButton
                      label={formData.status === SubscriberService.STATUS_ACTIVE ? t('Restart') : t('Start')}
                      color={'success'}
                      icon={'play'}
                      className={'mr-1'}
                      disabled={formData.status === SubscriberService.STATUS_PENDING}
                      onClickCallback={start}
                    />
                    <ActiveButton
                      label={t('Stop')}
                      color={'danger'}
                      icon={'stop'}
                      className={'mr-1'}
                      disabled={formData.status !== SubscriberService.STATUS_ACTIVE}
                      onClickCallback={stop}
                    />
                    <a href={`https://${formData.name}.avanga.org`} target="_blank">{`${formData.name}.avanga.org`}</a>
                    <br/>
                    <br/>
                  </Col>
                </Row>
              )}
              <Row>
                <Col md={formData.name && formData.domain && formData.logo_filename ? 9 : 12}>
                  <FormGroup row className="my-0">
                    <Col {...twoCols}>
                      <InputGroup
                        id="name"
                        label={t('Company name')}
                        name="name"
                        placeholder={t('Company name')}
                        onChange={onChange}
                        errors={errors}
                        value={formData.name}
                        icon="fa fa-circle"
                        disabled={!!formData.id}
                      />
                    </Col>
                    <Col {...twoCols}>
                      <InputGroup
                        id="title"
                        label={t('Title')}
                        name="title"
                        placeholder={t('Title')}
                        onChange={onChange}
                        errors={errors}
                        value={formData.title}
                        icon="fa fa-circle-o"
                      />
                    </Col>
                  </FormGroup>
                  <fieldset>
                    <FormGroup row className="my-0">
                      <Col {...twoCols}>
                        <InputGroup
                          id="username"
                          label={t('Username')}
                          name="username"
                          placeholder={t('Username')}
                          onChange={onChange}
                          errors={errors}
                          value={formData.username}
                          icon="fa fa-user"
                        />
                      </Col>
                      <Col {...twoCols}>
                        <InputGroup
                          id="email"
                          label={t('E-mail')}
                          name="email"
                          placeholder={t('E-mail')}
                          onChange={onChange}
                          errors={errors}
                          value={formData.email}
                          icon="fa fa-at"
                        />
                      </Col>
                    </FormGroup>
                    <FormGroup row className="my-0">
                      <Col {...twoCols}>
                        <InputGroup
                          id="first_name"
                          label={t('First name')}
                          name="first_name"
                          placeholder={t('First name')}
                          onChange={onChange}
                          errors={errors}
                          value={formData.first_name}
                          icon="fa fa-address-card-o"
                        />
                      </Col>
                      <Col {...twoCols}>
                        <InputGroup
                          id="last_name"
                          label={t('Last name')}
                          name="last_name"
                          placeholder={t('Last name')}
                          onChange={onChange}
                          errors={errors}
                          value={formData.last_name}
                          icon="fa fa-address-card-o"
                        />
                      </Col>
                    </FormGroup>
                    <FormGroup row className="my-0">
                      <Col {...twoCols}>
                        <InputGroup
                          id="phone"
                          label={t('Phone')}
                          name="phone"
                          placeholder={t('Phone')}
                          onChange={onChange}
                          errors={errors}
                          value={formData.phone}
                          icon="fa fa-phone"
                        />
                      </Col>
                      <Col {...twoCols}>

                      </Col>
                    </FormGroup>
                    <FormGroup row className="my-0">
                      <Col {...twoCols}>
                        <InputGroup
                          id="country"
                          label={t('Country')}
                          name="country"
                          placeholder={t('Country')}
                          onChange={onChange}
                          errors={errors}
                          value={formData.country}
                          icon="fa fa-flag"
                        />
                      </Col>
                      <Col {...twoCols}>
                        <InputGroup
                          id="address"
                          label={t('Address')}
                          name="address"
                          placeholder={t('Address')}
                          onChange={onChange}
                          errors={errors}
                          value={formData.address}
                          icon="fa fa-street-view"
                        />
                      </Col>
                    </FormGroup>
                  </fieldset>
                  <FormGroup row className="my-0">
                    <Permissions allowed={['update_subscribers']}>
                      <Col {...twoCols}>

                      </Col>
                      <Col {...twoCols}>

                      </Col>
                    </Permissions>
                  </FormGroup>
                  {/*<FormGroup row className="my-0">*/}
                    {/*<Permissions allowed={['update_subscribers']}>*/}
                      {/*<Col {...twoCols}>*/}
                        {/*<InputGroup*/}
                          {/*label={t('Payment status')}*/}
                          {/*name="payment_status"*/}
                          {/*type="select"*/}
                          {/*onChange={onChange}*/}
                          {/*errors={errors}*/}
                          {/*value={formData.payment_status}*/}
                          {/*options={paymentStatusList}*/}
                          {/*icon="fa fa-cog"*/}
                        {/*/>*/}
                      {/*</Col>*/}
                      {/*<Col {...twoCols}>*/}
                        {/*<InputGroup*/}
                          {/*label={t('Payment types')}*/}
                          {/*name="payment_type"*/}
                          {/*type="select"*/}
                          {/*onChange={onChange}*/}
                          {/*errors={errors}*/}
                          {/*value={formData.payment_type}*/}
                          {/*options={paymentTypesList}*/}
                          {/*icon="fa fa-cog"*/}
                        {/*/>*/}
                      {/*</Col>*/}
                    {/*</Permissions>*/}
                  {/*</FormGroup>*/}
                  {!!formData.id && (
                    <FormGroup row className="my-0">
                      <Col {...twoCols}>
                        <InputGroup
                          label={t('Status')}
                          name="status"
                          type="select"
                          onChange={onChange}
                          errors={errors}
                          value={formData.status}
                          options={statusList}
                          icon="fa fa-cog"
                        />
                      </Col>
                      <Col {...twoCols}>
                        <InputGroup
                          label={t('Ext modules')}
                          name="modules"
                          type="select2"
                          onChange={onChange}
                          errors={errors}
                          value={formData.modules}
                          options={modules}
                          empty="-"
                          icon="fa fa-rocket"
                          isMulti
                        />
                      </Col>
                    </FormGroup>
                  )}
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <SubmitButtons
                    isSubmitting={isSubmitting}
                    onSubmit={onSubmit}
                    isSubmittingRedirect={isSubmittingRedirect}
                  />
                </Col>
              </Row>

            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

Subscriber.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isSubmittingRedirect: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  // match: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  image: PropTypes.object,
  statusList: PropTypes.array.isRequired,
  licenceList: PropTypes.array.isRequired,
};

export default Subscriber;



// WEBPACK FOOTER //
// ./src/views/subscribers/subscriber/Subscriber.jsx